import { lazy } from "react";

// @ts-ignore
export default lazy(() => import("./components/allClaimsV2/AllClaimsV2"));
